import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { View, Text, Pressable, Image } from 'react-native';
import { MainContainer, ContentContainer, PageTitle, TableContainer } from '../../elements';
import { HIDE_TITLE_LOG, TITLE_LOGS_WITH_COUNT } from './queries';
import { useMutation } from '@apollo/client';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import Modal from '../../elements/Modal';
import { Document, Page, pdfjs } from 'react-pdf';
import EditTitleLog from './edit';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import { TITLE_LOG_STATUSES } from './constants';
export { TITLE_LOG_STATUSES };

const inputStyle = {
  marginBottom: '10px'
}


const TitleLogs = (props) => {
// console.log('props', props)
//   const { asset } = props?.asset;
  // const [assetId, setAssetId] = useState(props.assetId)
  const { sellerId, assetId} = useParams();
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [showTitleLogModal, setShowTitleLogModal] = useState(false);
  const [showEditTitleLogModal, setShowEditTitleLogModal] = useState(false);
  const [clickedTitleLog, setClickedTitleLog] = useState();
  const queryVariables = {
    assetId: assetId,
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideTitleLog] = useMutation(
    HIDE_TITLE_LOG, { onCompleted: refetch }
  )

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'id',
      label: 'Date',
      sort: 'desc',
      content: ({ entry }) => (
        <Text>{moment(entry.createdAt).format('M/D/YY')}</Text>
      )
    },
    {
      key: 'assetId',
      label: 'Asset',
      hidden: assetId,
      content: (entry) => {
        return (
          <View>
            <Link to={`/sellers/${entry.entry.asset?.seller?.id}/assets/${entry.entry.asset?.id}`}>
              {entry.entry.asset.name}
            </Link>
          </View>
        )
      }
    },
    {
      key: 'vin',
      label: 'VIN',
      content: (entry) => {
        return (
          <View>
            <Link to={`/sellers/${entry.entry.asset?.seller?.id}/assets/${entry.entry.asset?.id}`}>
              {entry.entry.asset.vin}
            </Link>
          </View>
        )
      }
    },
    {
      key: 'sellerName',
      label: 'Seller',
      value: ({entry}) => entry.seller?.name,
      content: (entry) => {
        // console.log(entry)
        return (
          <View>
            <Link to={`/sellers/${entry.entry.asset.seller.id}`}>
              {entry.entry.asset.seller.name}
            </Link>
          </View>
        )
      }
    },
    {
      key: 'status',
      label: 'Status',
    },
    {
      key: 'trackingNumber',
      label: 'Tracking Number',
      value: ({ entry, value }) => {
        if (value && entry.trackingShipper) {
          return `${value} - ${entry.trackingShipper}`;
        } else {
          return value
        }
      }
    },
    {
      key: 'notes',
      label: 'Notes',
      content: ({ entry, value }) => (
        <View>
          {'Release' === entry.status &&
            entry.asset.titleReleaseWarning && (
            <Text style={{color: 'red', fontWeight: 600}}>
              {entry.asset.titleReleaseWarning}
            </Text>
          )}
          <Text>{value}</Text>
        </View>
      )
    },
    {
      key: 'upload',
      label: 'File',
      sort: 'prevent',
      content: ({ entry }) => {
        if(entry.upload) {
          return (
            <Link to={entry.upload.url} target='_blank'>
              <Text>
                {entry.upload.filename}
              </Text>
            </Link>
          )
        }else {
          <Link to={entry.linkedAttachment?.url} target='_blank'>
            <Text>
              {`${entry.linkedAttachment?.name} (linked)`}
            </Text>
          </Link>
        }
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <Pressable
              onPress={() => {
                setShowEditTitleLogModal(true);
                setClickedTitleLog(entry)
              }}
            >
            <Text>Edit</Text>
            </Pressable>
          </View>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <Text>Seller Name:</Text>
        <input
          type={'text'}
          name="sellerName"
          onChange={e => setFilter('sellerName', e.target.value)}
          value={filters.sellerName || ''}
          style={inputStyle}
        />
        <Text>VIN:</Text>
        <input
          type={'text'}
          name="vin"
          onChange={e => setFilter('vin', e.target.value)}
          value={filters.vin || ''}
          style={inputStyle}
        />
        <Text>Status:</Text>
        <select
          type={'select'}
          name="status"
          style={{marginBottom: 20}}
          onChange={e => setFilter('status', e.target.value)}
          value={filters.status || ''}
        >
          <option value="">All</option>
        {TITLE_LOG_STATUSES.map(status => (
          <option key={`status-${status}`} value={status}>
            {status}
          </option>
          ))}
        </select>
        {/* <View style={{padding: '20px'}}>

          <Text>Make:</Text>
          <input
            type={'text'}
            name="make"
            onChange={e => setFilter('make', e.target.value)}
            value={filters.make || ''}
          />
          <Text>Model:</Text>
          <input
            type={'text'}
            name="model"
            onChange={e => setFilter('model', e.target.value)}
            value={filters.model || ''}
          />
        </View> */}
      </Filter>
      <ResetSettings />
    </View>
  );

// console.log('asset in title log index', asset)
  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>Title Logs</PageTitle>
        <br /><br />
        <TableContainer>
          <SubNav
            refetch={refetch}
            tableNav={true}
            assetId={assetId}
            // asset={asset}
          />
          <DataTable.Gql
            setRefetch={setRefetch}
            query={TITLE_LOGS_WITH_COUNT}
            queryName='titleLogsWithCount'
            columns={columns}
            buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.titleLogsWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditTitleLogModal &&
        <Modal
          refetch={refetch}
          showModal={showEditTitleLogModal}
          setShowModal={setShowEditTitleLogModal}
          modalType={'Edit Title Log'}
          objectName={clickedTitleLog.asset.name}
        >
          <EditTitleLog
            setShowModal={setShowEditTitleLogModal}
            refetch={refetch}
            knownTitleLog={clickedTitleLog}
            assetId={clickedTitleLog.assetId}
            assetMiles={clickedTitleLog.asset?.miles}
          />
        </Modal>
      }
      {showTitleLogModal &&
        <Modal
          refetch={refetch}
          showModal={showTitleLogModal}
          setShowModal={setShowTitleLogModal}
          modalType={'Title Log'}
          objectName={clickedTitleLog.filename}

        >
          {clickedTitleLog.contentType === "application/pdf" ?
            <embed src={clickedTitleLog?.url} /> :
            <img src={clickedTitleLog?.url} />
          }
        </Modal>
      }
    </MainContainer>
  )

  function displayPDF() {
    return (
      <Document
        file={src}
        options={{ workerSrc: "/pdf.worker.js" }}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    )
  }
}

export default TitleLogs;
